import { Component, OnInit, Inject } from '@angular/core';
import { SnackbarService } from '..';
import { Constants, ProductService } from '../../../core';
import { returnItemDetails, returnSaleNote, returnSaleNoteItems } from '../../../core/models/sale/return-sale-note.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-massive-product-return-dialog',
  templateUrl: './massive-product-return-dialog.component.html'
})
export class MassiveProductReturnDialogComponent implements OnInit {
  dispatchItemList: any = [];
  constructor(
    public dialogRef: MatDialogRef<MassiveProductReturnDialogComponent>,
    public snackbarService: SnackbarService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private productService: ProductService
  ) { 
    const listMotive = Constants.SaleNote.REASON_CANCELLATION.getProps();
    this.dispatchItemList = this.data.map((item: any) => {
      item.reasonCancellation = listMotive[0].text
      item.listMotive = listMotive;
      item.availableItems = item.cancelQuantity // eliminar propiedad luego de validar correctamente las cantidades
      item.canceledItems = item.cancelQuantity; // ver el calculo correcto de calculo de cantidad disponible
      item.skuCode = item.dispatchItems.skuCode
      item.packCode = item.dispatchItems.packCode
      item.origin = item.origin
      item.canceled = false;
      item.measurable = item.dispatchItems.measurable;
      item.conversionFactor = item.dispatchItems.conversionFactor;
      return item;
    });
  }

  ngOnInit() {
  }

  updateQuantityReturned(event) {
    const parseQuantity = this.productService.quantityRoundDecimal(this.dispatchItemList[event.index], Number(event.value));
    event.value = parseQuantity;
    const canceledItems: number = parseQuantity;
    const isDecimal = this.dispatchItemList[event.index].measurable ? 0 : 1;
    if (canceledItems >= isDecimal && canceledItems <= Number(event.data.availableItems)) {
      this.dispatchItemList[event.index].canceledItems = canceledItems;
    } else {
      this.dispatchItemList[event.index].canceledItems = 0;
    }
    this.dispatchItemList = JSON.parse(JSON.stringify(this.dispatchItemList))
  }

  changeSelectReason(event) {
    this.dispatchItemList[event.indice].reasonCancellation = event.selectChange.value;
  }

  onClosePartialReturned() {
    // this.dialogRef.close(this.cancellationResult);
    this.dialogRef.close();
  }

  onSubmitPartialReturned(){
    const returnSaleNoteRequest: returnSaleNote = {};
    returnSaleNoteRequest.items = [];
    returnSaleNoteRequest.items = this.dispatchItemList
    .map(dpc => {
      const returnSaleNoteItem: returnSaleNoteItems = {};
      returnSaleNoteItem.orderId = dpc.saleNoteId.toString();
      returnSaleNoteItem.companyCode = dpc.companyCode;
      returnSaleNoteItem.reasonCode = dpc.reasonCancellation;
      returnSaleNoteItem.reasonDescription = dpc.listMotive.find(m => m.id === dpc.reasonCancellation).text; 
      returnSaleNoteItem.origin = dpc.origin;
      const returnItemDetails: returnItemDetails = {};
      returnItemDetails.skuCode = dpc.skuCode;
      returnItemDetails.quantity = dpc.canceledItems;
      returnItemDetails.packCode = dpc.packCode;
      returnItemDetails.eanCode = dpc.eanCode;
      returnSaleNoteItem.items = [];
      returnSaleNoteItem.items.push(returnItemDetails);
      returnSaleNoteItem.reportDetailId = dpc.reportDetailId
      returnSaleNoteItem.dispatchItemId = dpc.dispatchItemId
      return returnSaleNoteItem;
    });
    if (returnSaleNoteRequest.items.length) {
      this.dialogRef.close(returnSaleNoteRequest);
    } else {
      this.snackbarService.show(
        'Debe ingresar correctamente las cantidades a eliminar.',
        'warning',
      );
      this.dialogRef.close();
    }
  }

}
